import { ApiHealthCheckResponse } from '@/types/api';
import { quickLog } from '@/utils/console-log';
import authenticatedAxios from '../axios';

/**
 * Get the current API health status
 */
export const getApiHealth = async (forceResponse?: string): Promise<ApiHealthCheckResponse> => {
  if (forceResponse) {
    quickLog.api('Returning forced API health status');
    return { environment: 'development', project: 'FieldOne API Mock', status: forceResponse };
  }

  const endpoint = 'app/health';
  const response = await authenticatedAxios.get<ApiHealthCheckResponse>(endpoint);
  return response.data;
};
